import styled from 'styled-components';

import { BaseBodyText } from 'pages/checkout/components/common/typographic-styled-components';

export const BookingRestrictedModalBody = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;

  row-gap: 20px;
`;

export const BookingRestrictedModalText = styled(BaseBodyText)`
  text-align: center;
`;
